export interface BedSensorCommandCatalogEntry {
	name: string;
	unit?: string;
	critical?: boolean;
}

export const BED_SENSOR_COMMAND_CATALOG: BedSensorCommandCatalogEntry[] = [
	{ name: "FReset" },
	{ name: "Reset" },
	{ name: "Info" },
	{ name: "UID" },
	{ name: "MacSTA" },
	{ name: "MacSAP" },
	{ name: "MacBLE" },
	{ name: "MacETH" },
	{ name: "Start" },
	{ name: "Stop" },
	{ name: "RunTime" },
	{ name: "Login" },
	{ name: "Save" },
	{ name: "STASSID" },
	{ name: "STAPASS" },
	{ name: "STAIP" },
	{ name: "STA", critical: true },
	{ name: "APSSID" },
	{ name: "APPASS" },
	{ name: "AP" },
	{ name: "HostBullseye" },
	{ name: "HostOpas" },
	{ name: "Host2BPS", critical: true },
	{ name: "WSP", unit: "ms", critical: true },
	{ name: "TSP", unit: "ms" },
	{ name: "LSP", unit: "ms" },
	{ name: "StatusSend" },
	{ name: "Baudrate", unit: "bps" },
	{ name: "TRANSFER" },
	{ name: "Debug" },
	{ name: "Detect" },
	{ name: "MinThr" },
	{ name: "MaxThr" },
	{ name: "FloorThr" },
	{ name: "MinS", unit: "m/s" },
	{ name: "MaxS", unit: "m/s" },
	{ name: "DropS", unit: "m/s" },
	{ name: "MovHit" },
	{ name: "DropHit" },
	{ name: "DropX", unit: "m" },
	{ name: "DropXM", unit: "m" },
	{ name: "DropThr" },
	{ name: "MovT", unit: "ms" },
	{ name: "MeasT", unit: "ms" },
	{ name: "DropT", unit: "ms" },
	{ name: "AlertT", unit: "ms" },
	{ name: "ClearT", unit: "ms" },
	{ name: "Left", unit: "m" },
	{ name: "Right", unit: "m" },
	{ name: "BedH", unit: "m" },
	{ name: "RadarH", unit: "m" },
	{ name: "Angle", unit: "degree" },
	{ name: "ModI", critical: true },
	{ name: "ModS", critical: true },
];
